import React from 'react';
import { RefreshCw, GitCompare, Building2, School } from 'lucide-react';

/**
 * AnalyticsFilterBar — Global controls above all analytics tab content.
 *
 * Props:
 *   filters: { days, compare, district_id, campus_id, deployment_version }
 *   onChange: (partialFilters) => void
 *   onRefresh: () => void
 *   loading: boolean
 */

const TIME_PRESETS = [
    { label: '7d', value: 7 },
    { label: '14d', value: 14 },
    { label: '30d', value: 30 },
    { label: '90d', value: 90 },
];

const AnalyticsFilterBar = ({ filters, onChange, onRefresh, loading = false }) => {
    const { days = 7, compare = false } = filters;

    return (
        <div style={{
            display: 'flex', alignItems: 'center', gap: 12,
            padding: '10px 0', marginBottom: 20,
            flexWrap: 'wrap',
        }}>
            {/* Timeframe presets */}
            <div style={{
                display: 'flex', gap: 2,
                background: '#f1f5f9', borderRadius: 10, padding: 3,
            }}>
                {TIME_PRESETS.map(p => (
                    <button
                        key={p.value}
                        onClick={() => onChange({ days: p.value })}
                        style={{
                            padding: '6px 14px', borderRadius: 8, border: 'none',
                            fontSize: 12, fontWeight: days === p.value ? 600 : 400,
                            cursor: 'pointer', transition: 'all 0.15s',
                            background: days === p.value ? '#fff' : 'transparent',
                            color: days === p.value ? '#0f172a' : '#64748b',
                            boxShadow: days === p.value ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                        }}
                    >
                        {p.label}
                    </button>
                ))}
            </div>

            {/* Compare toggle */}
            <button
                onClick={() => onChange({ compare: !compare })}
                style={{
                    display: 'flex', alignItems: 'center', gap: 6,
                    padding: '6px 14px', borderRadius: 8,
                    border: compare ? '1px solid #6366f1' : '1px solid #e2e8f0',
                    fontSize: 12, fontWeight: 500, cursor: 'pointer',
                    background: compare ? '#eef2ff' : '#fff',
                    color: compare ? '#4f46e5' : '#64748b',
                    transition: 'all 0.15s',
                }}
            >
                <GitCompare size={13} />
                Compare
            </button>

            {/* Spacer */}
            <div style={{ flex: 1 }} />

            {/* Refresh */}
            <button
                onClick={onRefresh}
                disabled={loading}
                style={{
                    display: 'flex', alignItems: 'center', gap: 6,
                    padding: '6px 14px', borderRadius: 8,
                    border: '1px solid #e2e8f0',
                    fontSize: 12, fontWeight: 500, cursor: loading ? 'default' : 'pointer',
                    background: '#fff', color: '#64748b',
                    opacity: loading ? 0.6 : 1,
                    transition: 'all 0.15s',
                }}
            >
                <RefreshCw size={13} style={{
                    animation: loading ? 'spin 1s linear infinite' : 'none',
                }} />
                Refresh
            </button>

            <style>{`
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default AnalyticsFilterBar;
